import React from 'react'
import IdPhotoContent from '../../../../components/SignUp/IdsScreens/IdPhotoContent/IdPhotoContent'

const IdSignUpFrontScreen = () => {
    return (
        <IdPhotoContent type="Front_id" />
    )
}

export default IdSignUpFrontScreen